import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import ol                                     from 'openlayers';
import features                               from "@/api/features";
import {FeatureTypes}                         from "@/util/enums/FeatureTypes";

@Module
export default class Map extends VuexModule {
    private _map: any;
    private _zoom              = 8;
    private _extent            = [];
    private _centerCoodrinates = [34.34296234233739, 56.906472014375254];

    private _batchesGeojson: any = {
        type    : "FeatureCollection",
        features: []
    };
    private _batchLoadingStatus  = '';

    private _projectGeojson: any = {
        type    : "FeatureCollection",
        features: []
    };

    private _pointsLayer: any;
    private _batchesLayer: any;

    get mapZoom() {
        return this._zoom;
    }

    get mapExtent() {
        return this._extent;
    }

    get mapCenterCoordinates() {
        return this._centerCoodrinates;
    }

    get mapBatchesGeojson() {
        return this._batchesGeojson;
    }

    get mapProjectGeojson() {
        return this._projectGeojson;
    }

    get mapProjectFeatures() {
        if (this._projectGeojson && 'features' in this._projectGeojson) {
            return this._projectGeojson.features;
        }

        return [];
    }

    get mapBatchFeatures() {
        if (this._batchesGeojson && 'features' in this._batchesGeojson) {
            return this._batchesGeojson.features;
        }

        return [];
    }

    get mapPointsLayer() {
        return this._pointsLayer;
    }

    get mapBatchesLayer() {
        return this._batchesLayer;
    }

    @Mutation
    setMap(map: any) {
        this._map = map;
    }

    @Mutation
    setExtent(extent: any) {
        this._extent = extent;
    }

    @Mutation
    setZoom(value: number) {
        this._zoom = value;
    }

    @Mutation
    setCenterCoordinates(coordinates: Array<number>) {
        this._centerCoodrinates = coordinates;
    }

    @Mutation
    setBatchesGeojson(geojson: any) {
        this._batchesGeojson = geojson;
    }

    @Mutation
    setProjectGeojson(geojson: any) {
        this._projectGeojson = geojson;
    }

    @Mutation
    setBatchLoadingStatus(status: string) {
        this._batchLoadingStatus = status;
    }

    @Action
    async loadBatches() {
        if (this._batchLoadingStatus !== 'loading') {
            this.context.commit('setBatchLoadingStatus', 'loading');
            await features.getFeatures(this._extent, FeatureTypes.Batch).then((response) => {
                this.context.commit('setBatchLoadingStatus', 'success');
                this.context.commit('setBatchesGeojson', response.data);
            }).catch(() => {
                this.context.commit('setBatchLoadingStatus', 'fail');
            })
        }
    }

    @Action
    async loadProjects() {
        await features.getFeatures([], FeatureTypes.Project).then((response) => {
            this.context.commit('setProjectGeojson', response.data);
        }).catch(() => {
            //todo
        })
    }

    @Action({commit: 'setCenterCoordinates'})
    focusToCoordinates(coordinates: Array<number>, zoom = 15) {
        this.context.commit('setZoom', zoom);
        return coordinates;
    }

    @Action
    focusToFeature(feature: ol.Feature | ol.render.Feature, maxZoom = 14) {
        this._map.getView().fit(feature.getGeometry(), {maxZoom: maxZoom});
    }

    @Action({commit: 'setExtent'})
    calculateExtent() {
        const extent = this._map.getView().calculateExtent(this._map.getSize());
        return ol.proj.transformExtent(extent, "EPSG:3857", "EPSG:4326");
    }
}